import { render } from "./NcrmMailjetSendEmailDialog.vue?vue&type=template&id=2cf404c7&scoped=true"
import script from "./NcrmMailjetSendEmailDialog.vue?vue&type=script&lang=js"
export * from "./NcrmMailjetSendEmailDialog.vue?vue&type=script&lang=js"

import "./NcrmMailjetSendEmailDialog.vue?vue&type=style&index=0&id=2cf404c7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf404c7"]])

export default __exports__